"use client";

import { Card, CardContent, CardHeader, CardTitle } from "@stocks/ui";
import { IMAGE_FEATURE_STATUS } from "@stocks/shared";

import {
  ItemCategoryBadge,
  ZoomableImage,
  useItem,
  useItemImages,
} from "@/entities/item";
import { ItemEditForm } from "@/features/item/update-item";

/** 품목 상세: 기본 정보 + 저장된 사진(확대 보기) + 수정/사용 중지 */
export const ItemDetail = ({ id }: { id: string }) => {
  const { data: item, isLoading, isError } = useItem(id);
  const { data: images = [] } = useItemImages(id);

  if (isLoading) return <p className='text-muted-foreground'>불러오는 중…</p>;
  if (isError || !item)
    return <p className='text-destructive'>품목을 찾을 수 없습니다.</p>;

  return (
    <div className='grid gap-6 lg:grid-cols-2'>
      <Card>
        <CardHeader>
          <CardTitle className='flex flex-wrap items-center gap-2'>
            {item.name}
            <span className='text-sm font-normal text-muted-foreground'>
              {item.code}
            </span>
            <ItemCategoryBadge category={item.category} />
            {!item.isActive && (
              <span className='text-sm text-destructive'>사용 중지</span>
            )}
          </CardTitle>
        </CardHeader>
        <CardContent className='flex flex-col gap-4'>
          <div>
            <h3 className='mb-2 text-sm font-medium'>
              사진 ({images.length})
            </h3>
            {images.length === 0 ? (
              <p className='text-sm text-muted-foreground'>
                등록된 사진이 없습니다.
              </p>
            ) : (
              <ul className='flex flex-wrap gap-2'>
                {images.map((img, i) => (
                  <li key={img.id} className='relative'>
                    <ZoomableImage
                      path={img.path}
                      alt={`${item.name} 사진 ${i + 1}`}
                      className='size-24'
                    />
                    {img.path === item.imageUrl && (
                      <span className='absolute bottom-1 left-1 rounded bg-primary px-1 text-[10px] text-primary-foreground'>
                        대표
                      </span>
                    )}
                    {img.featureStatus !== IMAGE_FEATURE_STATUS.DONE && (
                      <span className='absolute top-1 left-1 rounded bg-background/80 px-1 text-[10px]'>
                        {img.featureStatus === IMAGE_FEATURE_STATUS.FAILED
                          ? "분석 실패"
                          : "분석 중"}
                      </span>
                    )}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>품목 정보 수정</CardTitle>
        </CardHeader>
        <CardContent>
          <ItemEditForm item={item} />
        </CardContent>
      </Card>
    </div>
  );
};
